// useCanEdit — hook simple para condicionar botones de modificación.
// Devuelve true SOLO si el usuario es superadmin.
// Uso típico:
//   const canEdit = useCanEdit()
//   {canEdit && <button onClick={borrar}>Borrar</button>}
//
// También sirve para deshabilitar inputs en lugar de ocultar:
//   <input disabled={!canEdit} ... />
//
// Para casos donde admin puede ver pero no actuar, mostrar tooltip:
//   <button disabled={!canEdit} title={!canEdit ? 'Solo superadmin puede modificar' : ''}>

import { useAuth } from './AuthContext'

export function useCanEdit() {
  const { isSuperadmin } = useAuth()
  return isSuperadmin
}
